import React from 'react';
import { GoogleLogin } from '@react-oauth/google';

const GoogleSignInButton = ({ onSignIn }) => {
  return (
    <div data-testid="google-signin-button">
      <GoogleLogin
        shape="pill"
        width="full"
        auto_select={false}
        onSuccess={response => {
          onSignIn(response);
        }}
        onError={() => {
          console.error('Login with Google Failed');
        }}
      />
    </div>
  );
};

export default GoogleSignInButton;
